import Shell from '../components/Shell';
import type { Branding } from '../types';

interface LocationRequiredPageProps {
  branding: Branding;
  busy: boolean;
  onRetry: () => void;
}

const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
const isAndroid = /Android/.test(navigator.userAgent);

// Only reached when the link requires location (deviceLocation=REQUIRED) and
// the browser didn't give us a position. iOS Safari never asks again once the
// person said no, so it has to be turned back on in Settings.
export default function LocationRequiredPage({ branding, busy, onRetry }: LocationRequiredPageProps) {
  return (
    <Shell branding={branding}>
      <h1>Necesitamos tu ubicación</h1>
      <p className="lead">Esta verificación requiere la ubicación de tu dispositivo para continuar.</p>

      <ul className="tips-list">
        {isIOS && (
          <>
            <li>Abre Ajustes → Privacidad y seguridad → Localización y verifica que esté activada.</li>
            <li>En la misma pantalla, busca tu navegador (Safari o Chrome) y elige «Al usar la app».</li>
            <li>Vuelve a esta página y toca «Ya lo habilité».</li>
          </>
        )}
        {isAndroid && (
          <>
            <li>Activa la ubicación desde el panel de ajustes rápidos.</li>
            <li>Toca el ícono a la izquierda de la dirección del sitio → Permisos → Ubicación → Permitir.</li>
          </>
        )}
        {!isIOS && !isAndroid && (
          <>
            <li>Haz clic en el ícono a la izquierda de la dirección del sitio y permite la ubicación.</li>
            <li>Verifica que los servicios de ubicación de tu computadora estén activados.</li>
          </>
        )}
      </ul>

      <button className="btn-primary" disabled={busy} onClick={onRetry}>
        {busy ? 'Iniciando…' : 'Ya lo habilité, reintentar'}
      </button>
    </Shell>
  );
}
